import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { FiLock } from "react-icons/fi";
import bcrypt from "bcryptjs";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../firebase";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleLogin = async () => {
    setLoading(true);
    setError("");

    try {
      const adminDocRef = doc(db, "admins", email);
      const adminSnapshot = await getDoc(adminDocRef);

      if (!adminSnapshot.exists()) {
        throw new Error("Invalid email or password");
      }

      const adminData = adminSnapshot.data();
      const passwordMatch = await bcrypt.compare(password, adminData.passwordHash);

      if (!passwordMatch) {
        throw new Error("Invalid email or password");
      }

      localStorage.setItem(
        "adminInfo",
        JSON.stringify({
          uid: adminData.email,
          email: adminData.email,
          name: adminData.displayName || adminData.email,
          role: adminData.role || "admin",
        })
      );

      navigate("/admin");
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-[#0f1514] p-4 text-white">
      <div className="w-full max-w-md rounded-[2rem] border border-white/10 bg-[#17201f] p-10 shadow-2xl shadow-black/30">
        <div className="mb-4 flex justify-center">
          <div className="rounded-full bg-[#A87F23] p-4 shadow-lg">
            <FiLock className="h-6 w-6 text-[#0f1514]" />
          </div>
        </div>

        <h1 className="mb-2 text-center text-3xl font-black tracking-[0.12em] text-[#A87F23]">MATCHES PRO</h1>
        <p className="mb-6 text-center text-sm uppercase tracking-[0.28em] text-[#819C97]">Admin Login</p>

        {error && <p className="mb-4 text-center font-medium text-red-400">{error}</p>}

        <div className="space-y-4">
          <input
            type="email"
            placeholder="Email"
            className="w-full rounded-xl border border-white/10 bg-[#0f1514] p-3 text-white placeholder-slate-500 transition focus:border-[#819C97] focus:outline-none"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          <input
            type="password"
            placeholder="Password"
            className="w-full rounded-xl border border-white/10 bg-[#0f1514] p-3 text-white placeholder-slate-500 transition focus:border-[#819C97] focus:outline-none"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
        </div>

        <button
          onClick={handleLogin}
          className="mt-6 w-full rounded-xl bg-[#A87F23] py-3 font-bold text-[#0f1514] transition hover:bg-[#c19432] disabled:opacity-50"
          disabled={loading}
        >
          {loading ? "Logging in..." : "Login"}
        </button>

        <p className="mt-4 text-center text-sm text-slate-400">Enter your admin credentials to continue.</p>
      </div>
    </div>
  );
}
